import React, { useEffect, useState } from 'react';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import PartnerService from '../../services/partner.service';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
import styles from './Partners.module.css';
import { getLocaleContent } from '@helper/locale-content.js';
import { useRouter } from 'next/router';

export default function Partners() {
    const { locale } = useRouter();
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        const partnerService = new PartnerService();
        partnerService
            .getPartnerHome({})
            .then(response => {
                setPartners(response);
            })
            .catch(error => {
                console.error('Error fetching partners:', error);
            });
    }, []);

    const swiperConfig = {
        autoplay: {
            delay: 2500,
        },
        loop: true,
        spaceBetween: 20,
        navigation: {
            nextEl: `.${styles['nav']} .bw_hover_prev`,
            prevEl: `.${styles['nav']} .bw_hover_next`,
        },
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 7,
            },
        },
    };

    return (
        <>
            <div className={styles['partner-wrapper']}>
                <header>
                    <h2 className={styles['title']}>
                        <span>{getLocaleContent(locale, 'page.partner.title1')}</span> {getLocaleContent(locale, 'page.partner.title2')}
                    </h2>
                </header>
                <div className={styles['logo-wrapper']}>
                    <Swiper {...swiperConfig}>
                        {partners.map(partner => (
                            <SwiperSlide key={partner.partner_id}>
                                <article className={styles['svc-card']}>
                                    <figure className={styles['svc-card__media']}>
                                        <img
                                            src={partner.image_avatar}
                                            alt={`Partner ${partner.partner_id}`}
                                        />
                                    </figure>
                                </article>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>
                <div className={styles['nav']}>
                    <button className="navbtn bw_hover_next" aria-label="Prev"></button>
                    <button className="navbtn bw_hover_prev" aria-label="Next"></button>
                </div>
            </div >
        </>
    );
}
